import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Select } from 'antd';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';
import {
    getReasoningEfforts,
    REASONING_EFFORT_LABELS,
    resolveReasoningEffort,
} from '../utils/reasoning';
import BrainIcon from './BrainIcon';

const ReasoningControl = observer(() => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const model = chatStore.selectedModelInfo;
    const reasoning = model?.reasoning;
    const efforts = useMemo(() => getReasoningEfforts(reasoning), [reasoning]);

    if (!efforts.length) return null;

    const value = resolveReasoningEffort(reasoning, chatStore.settings.reasoning_effort);

    return (
        <div
            className={`flex min-w-0 items-center gap-2 text-xs ${
                isDark ? 'text-white/70' : 'text-black/60'
            }`}
        >
            <span
                className={`inline-flex shrink-0 ${
                    isDark ? 'text-white/55' : 'text-black/45'
                }`}
                title="Уровень рассуждений"
            >
                <BrainIcon size={15} title="Уровень рассуждений" />
            </span>
            <Select
                size="small"
                value={value || undefined}
                className={`bananas-composer-select min-w-[108px] flex-1 sm:w-[124px] sm:flex-none ${
                    isDark
                        ? '[&_.ant-select-selector]:!bg-white/5 [&_.ant-select-selector]:!border-white/10 [&_.ant-select-selector]:!shadow-none [&_.ant-select-selection-item]:!text-gray-100 [&_.ant-select-arrow]:!text-white/45 [&_.ant-select-selector]:hover:!border-white/20'
                        : '[&_.ant-select-selector]:!bg-white [&_.ant-select-selector]:!border-black/15 [&_.ant-select-selection-item]:!text-gray-900 [&_.ant-select-arrow]:!text-black/40'
                }`}
                popupClassName={`bananas-composer-dropdown ${
                    isDark ? 'bananas-composer-dropdown--dark' : ''
                }`}
                popupMatchSelectWidth={false}
                getPopupContainer={() => document.body}
                options={efforts.map((e) => ({
                    value: e,
                    label: REASONING_EFFORT_LABELS[e] || e,
                }))}
                onChange={(v) => {
                    chatStore.settings.reasoning_effort = v;
                    chatStore.saveSettings({ reasoning_effort: v });
                    chatStore.schedulePersistChatParams();
                }}
            />
        </div>
    );
});

export default ReasoningControl;
